import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown, Checkbox } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import "./FormAlumnos.css";
import { map } from "lodash";

export function FormAlumnos(props) {
  const { alumno } = props;
  const [alumnos, setAlumnos] = useState(null);
  const [refetch] = useState(false);
  const { auth } = useAuth();
  const [grupos, setGrupos] = useState(null);
  const [grupoFormato, setGrupoFormato] = useState([]);
  // eslint-disable-next-line
  const [grupo, setGrupo] = useState(null);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  const [alumnoRegistrado, setAlumnoRegistrado] = useState(null);

  const [estadoOptions, setEstadoOptions] = useState([]);
  const [municipioOptions, setMunicipioOptions] = useState([]);
  const [coloniaOptions, setColoniaOptions] = useState([]);

  const [estadoOptionsTutor, setEstadoOptionsTutor] = useState([]);
  const [municipioOptionsTutor, setMunicipioOptionsTutor] = useState([]);
  const [coloniaOptionsTutor, setColoniaOptionsTutor] = useState([]);

  const [showEstadoInput, setShowEstadoInput] = useState(false);
  const [showColoniaInput, setShowColoniaInput] = useState(false);
  const [showMunicipioInput, setShowMunicipioInput] = useState(false);

  const [showEstadoInputTutor, setShowEstadoInputTutor] = useState(false);
  const [showColoniaInputTutor, setShowColoniaInputTutor] = useState(false);
  const [showMunicipioInputTutor, setShowMunicipioInputTutor] = useState(false);

  const handleCPChange = async (e) => {
    const cp = e.target.value;
    try {
      const response = await axios.get(
        `https://data.opendatasoft.com/api/records/1.0/search/?dataset=geonames-postal-code%40public&q=${cp}&facet=country_code&facet=admin_name1&facet=admin_code1&facet=admin_name2&refine.country_code=MX`
      );
      const data = response.data;
      // Obtener datos de estado, municipio y colonia
      const estados = [
        ...new Set(data.records.map((record) => record.fields.admin_name1)),
      ];
      const municipios = [
        ...new Set(data.records.map((record) => record.fields.admin_name2)),
      ];
      const colonias = [
        ...new Set(data.records.map((record) => record.fields.place_name)),
      ];

      setEstadoOptions(
        estados.map((estado) => ({ key: estado, text: estado, value: estado }))
      );
      setMunicipioOptions(
        municipios.map((municipio) => ({
          key: municipio,
          text: municipio,
          value: municipio,
        }))
      );
      setColoniaOptions(
        colonias.map((colonia) => ({
          key: colonia,
          text: colonia,
          value: colonia,
        }))
      );

      if (alumno) {
        setShowEstadoInput(false);
        setShowColoniaInput(false);
        setShowMunicipioInput(false);
      }

      formik.setFieldValue("codigo_postal_domicilio", cp);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };

  const handleCPChangeTutor = async (e) => {
    const cp = e.target.value;
    try {
      const response = await axios.get(
        `https://data.opendatasoft.com/api/records/1.0/search/?dataset=geonames-postal-code%40public&q=${cp}&facet=country_code&facet=admin_name1&facet=admin_code1&facet=admin_name2&refine.country_code=MX`
      );
      const data = response.data;
      // Obtener datos de estado, municipio y colonia
      const estados = [
        ...new Set(data.records.map((record) => record.fields.admin_name1)),
      ];
      const municipios = [
        ...new Set(data.records.map((record) => record.fields.admin_name2)),
      ];
      const colonias = [
        ...new Set(data.records.map((record) => record.fields.place_name)),
      ];

      setEstadoOptionsTutor(
        estados.map((estado) => ({ key: estado, text: estado, value: estado }))
      );
      setMunicipioOptionsTutor(
        municipios.map((municipio) => ({
          key: municipio,
          text: municipio,
          value: municipio,
        }))
      );
      setColoniaOptionsTutor(
        colonias.map((colonia) => ({
          key: colonia,
          text: colonia,
          value: colonia,
        }))
      );

      if (alumno) {
        setShowEstadoInputTutor(false);
        setShowColoniaInputTutor(false);
        setShowMunicipioInputTutor(false);
      }

      formik.setFieldValue("codigo_postal_domicilio_tutor", cp);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };

  async function getGruposApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getGruposApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setGrupoFormato(formatoDelDropDown(grupos));
  }, [grupos]);

  async function getGrupoApi(grupo_id) {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/grupo/${grupo_id}/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupo(result);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function updateGrupo(grupoId, nuevoAlumnoId, dataGrupo) {
    await eliminarAlumnoDelGrupoAntiguo(nuevoAlumnoId);
    try {
      const url = `${BASE_API}/api/grupo/${grupoId}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const alumnosIds = dataGrupo.alumnos.map((alumno) => parseInt(alumno));
      const nuevaListaAlumnosIds = [...alumnosIds, parseInt(nuevoAlumnoId)];
      const data = {
        numero_grupo: dataGrupo.numero_grupo,
        capacidad: dataGrupo.capacidad,
        alumnos: nuevaListaAlumnosIds,
      };

      const response = await axios.put(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function getGrupoActualDelAlumno(alumnoId) {
    try {
      // Buscar todos los grupos
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const grupos = response.data;

      // Buscar el grupo que contiene al alumno
      const grupoActual = grupos.find((grupo) =>
        grupo.alumnos.includes(alumnoId)
      );

      return grupoActual;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function eliminarAlumnoDelGrupoAntiguo(alumnoId) {
    try {
      // Obtener el grupo actual del alumno
      const grupoActual = await getGrupoActualDelAlumno(alumnoId);

      // Verificar si el grupo actual está definido
      if (grupoActual && grupoActual.id_grupo) {
        // Eliminar al alumno del grupo actual
        const url = `${BASE_API}/api/grupo/${grupoActual.id_grupo}/`; // URL del grupo actual
        const headers = {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        };
        const alumnosIdsActualizados = grupoActual.alumnos.filter(
          (id) => id !== alumnoId
        );
        const data = {
          ...grupoActual,
          alumnos: alumnosIdsActualizados,
        };
        await axios.put(url, data, { headers });
      } else {
        console.error("No se pudo obtener el grupo actual del alumno.");
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function getAlumnosApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/alumno/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setAlumnos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnosApi();
    // eslint-disable-next-line
  }, [refetch]);

  const addAlumno = async (data) => {
    try {
      const result = await createAlumnoApi(data, auth.token);
      setAlumnoRegistrado(result);
      return result.id; // Devolver el ID del alumno registrado
    } catch (error) {
      throw error;
    }
  };

  const updateAlumno = async (alumnoId, data) => {
    try {
      await updateAlumnoApi(alumnoId, data, auth.token);
      return alumnoId; // Devolver el ID del alumno actualizado
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (alumnoRegistrado !== null) {
      toast.success("Alumno registrado exitosamente");
    }
  }, [alumnoRegistrado]);

  async function createAlumnoApi(data) {
    try {
      setLoading(true);
      const url = `${BASE_API}/api/alumno/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.post(url, data, { headers });
      const result = response.data;
      setAlumnoRegistrado(result);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        const existingAlumno = alumnos.find(
          (alumno) => alumno.curp === data.curp
        );
        const existingAlumnoMatricula = alumnos.find(
          (alumno) => alumno.matricula === data.matricula
        );
        if (existingAlumno) {
          toast.error("Alumno con esa curp ya registrado");
        }
        if (existingAlumnoMatricula) {
          toast.error("Alumno con esa matricula ya registrado");
        }
        if (error.response.data.fecha_nacimiento !== undefined) {
          toast.error("" + error.response.data.fecha_nacimiento[0]);
        }
        if (error.response.data.num_afiliacion !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.num_afiliacion[0]
          );
        }
      }
      throw error;
    }
  }

  async function updateAlumnoApi(id, data) {
    try {
      const url = `${BASE_API}/api/alumno/${id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      toast.success("Datos actualizados exitosamente");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.numero_grupo !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.numero_grupo[0]
          );
        }
        if (error.response.data.matricula !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.matricula[0]
          );
        }
        if (error.response.data.num_afiliacion !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.num_afiliacion[0]
          );
        }
        if (error.response.data.fecha_nacimiento !== undefined) {
          toast.error("" + error.response.data.fecha_nacimiento[0]);
        }
      }
      throw error;
    }
  }

  const generos = [
    { key: "1", text: "M", value: "M" },
    { key: "2", text: "H", value: "H" },
  ];

  const optionsSN = [
    { key: "1", text: "Si", value: "Si" },
    { key: "2", text: "No", value: "No" },
  ];

  const tiposDeSangre = [
    { key: "1", text: "A+", value: "A+" },
    { key: "2", text: "O+", value: "O+" },
    { key: "3", text: "B+", value: "B+" },
    { key: "4", text: "AB+", value: "AB+" },
    { key: "5", text: "A-", value: "A-" },
    { key: "6", text: "O-", value: "O-" },
    { key: "7", text: "B-", value: "B-" },
    { key: "8", text: "AB-", value: "AB-" },
  ];

  const servicioMedico = [
    { key: "1", text: "IMSS", value: "IMSS" },
    { key: "2", text: "ISSSTE", value: "ISSSTE" },
    { key: "4", text: "SEGURO POPULAR", value: "SEGURO POPULAR" },
    { key: "5", text: "SEMAR (SECRETARÍA DE MARINA)", value: "SEMAR" },
    {
      key: "6",
      text: "SEDENA (SECRETARÍA DE LA DEFENSA NACIONAL)",
      value: "SEDENA",
    },
    {
      key: "7",
      text: "SERVICIOS MÉDICOS DE PEMEX",
      value: "SERVICIOS MÉDICOS DE PEMEX",
    },
    { key: "8", text: "CONSULTORIOS PRIVADOS", value: "CONSULTORIOS PRIVADOS" },
    { key: "9", text: "HOSPITALES PRIVADOS", value: "HOSPITALES PRIVADOS" },
    { key: "3", text: "NINGUNO", value: "NINGUNO" },
  ];

  const semestres = [
    { key: "1", text: "I", value: 1 },
    { key: "2", text: "II", value: 2 },
    { key: "3", text: "III", value: 3 },
    { key: "4", text: "IV", value: 4 },
    { key: "5", text: "V", value: 5 },
    { key: "6", text: "VI", value: 6 },
    { key: "7", text: "VII", value: 7 },
    { key: "8", text: "VIII", value: 8 },
  ];

  // Función para calcular la edad a partir de la fecha de nacimiento
  function calcularEdad(fechaNacimiento) {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }
    return edad;
  }

  // Función para manejar el cambio en la fecha de nacimiento
  const handleFechaNacimientoChange = (e, { name, value }) => {
    formik.handleChange(e);
    formik.setFieldValue(name, value);

    // Calcular la edad y actualizar el campo de edad
    const edad = calcularEdad(value);
    formik.setFieldValue("edad", edad);
  };

  const formatName = (value) => {
    const parts = value.split(" ");
    const formattedParts = parts.map((part) => {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
    return formattedParts.join(" ");
  };

  useEffect(() => {
    const setInitialValues = async () => {
      if (grupos !== null) {
        formik.setValues(initialValues(alumno, grupos));
      }
    };
    setInitialValues();
    // eslint-disable-next-line
  }, [alumno, grupos]);

  const isValidDate = (dateString) => {
    // Use a more robust date validation
    return !isNaN(Date.parse(dateString));
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object(alumno ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        // Crear una copia del valor del formulario y limpiar las fechas inválidas
        const cleanedFormValue = { ...formValue };
        if (!isValidDate(formik.values.fecha_baja_temporal_1)) {
          cleanedFormValue.fecha_baja_temporal_1 = null;
        }
        if (!isValidDate(formik.values.fecha_baja_temporal_2)) {
          cleanedFormValue.fecha_baja_temporal_2 = null;
        }

        // Formatear otros campos del formulario
        cleanedFormValue.matricula =
          formValue.matricula.trim() === "" ? null : formValue.matricula.trim();
        cleanedFormValue.nombre = formatName(formValue.nombre);
        cleanedFormValue.apellido_paterno = formatName(
          formValue.apellido_paterno
        );
        cleanedFormValue.apellido_materno = formatName(
          formValue.apellido_materno
        );
        cleanedFormValue.nombre_tutor = formatName(formValue.nombre_tutor);
        cleanedFormValue.clave_plantelProc =
          formValue.clave_plantelProc.toUpperCase();
        cleanedFormValue.apellido_paterno_tutor = formatName(
          formValue.apellido_paterno_tutor
        );
        cleanedFormValue.apellido_materno_tutor = formatName(
          formValue.apellido_materno_tutor
        );

        let alumnoId;
        if (alumno) {
          await updateAlumno(alumno.id, cleanedFormValue);
          alumnoId = alumno.id;
        } else {
          alumnoId = await addAlumno(cleanedFormValue);
        }
        const grupoData = await getGrupoApi(cleanedFormValue.grupo);
        await updateGrupo(cleanedFormValue.grupo, alumnoId, grupoData);
        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (formik.errors) {
      const firstErrorField = Object.keys(formik.errors)[0];
      const errorElement = document.getElementsByName(firstErrorField)[0];
      if (errorElement) {
        errorElement.focus();
      }
    }
  }, [formik.isSubmitting, formik.errors]);

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <div className="fichero">
          <div className="titulo">
            <h3>Datos escolares</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>Matricula</label>
              <Form.Input
                name="matricula"
                placeholder="Matricula"
                value={formik.values.matricula || ""}
                onChange={(e) => {
                  const newValue = e.target.value.trim();
                  formik.setFieldValue("matricula", newValue);
                }}
                error={formik.errors.matricula}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Semestre <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="semestre"
                fluid
                selection
                search
                options={semestres}
                value={formik.values.semestre}
                error={formik.errors.semestre}
                onChange={(_, datos) => {
                  formik.setFieldValue("semestre", datos.value);
                }}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Grupo <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="Grupo"
                fluid
                selection
                search
                options={grupoFormato}
                value={formik.values.grupo}
                error={formik.errors.grupo}
                onChange={(_, datos) => {
                  formik.setFieldValue("grupo", datos.value);
                }}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            {alumno && (
              <div className="input-field">
                <label>
                  Estado del alumno <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="estado_alumno"
                  placeholder="Estado alumno"
                  value={formik.values.estado_alumno}
                  onChange={formik.handleChange}
                  error={formik.errors.estado_alumno}
                  readOnly
                />
              </div>
            )}
            <div className="input-field">
              <label>
                ¿Alumno de traslado? <span className="astedisco">*</span>
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  toggle
                  checked={formik.values.alumno_traslado}
                  onChange={(_, data) => {
                    formik.setFieldValue("alumno_traslado", data.checked);
                  }}
                  disabled={alumno && alumno.estado_alumno !== "Activo"}
                />
                <span style={{ marginLeft: "10px" }}>
                  {formik.values.alumno_traslado ? "Sí" : "No"}
                </span>
              </div>
            </div>
            {formik.values.alumno_traslado === true && (
              <div className="input-field">
                <label>Fecha baja temporal 1</label>
                <Form.Input
                  name="fecha_baja_temporal_1"
                  type="date"
                  value={formik.values.fecha_baja_temporal_1}
                  onChange={formik.handleChange}
                  error={formik.errors.fecha_baja_temporal_1}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
            {formik.values.alumno_traslado === true && (
              <div className="input-field">
                <label>Fecha baja temporal 2</label>
                <Form.Input
                  name="fecha_baja_temporal_2"
                  type="date"
                  value={formik.values.fecha_baja_temporal_2}
                  onChange={formik.handleChange}
                  error={formik.errors.fecha_baja_temporal_2}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
          </div>
        </div>
        <div className="fichero">
          <div className="titulo">
            <h3>Datos Generales</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>
                Apellido paterno <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="apellido_paterno"
                placeholder="Apellido paterno"
                value={formik.values.apellido_paterno}
                onChange={formik.handleChange}
                error={formik.errors.apellido_paterno}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Apellido materno <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="apellido_materno"
                placeholder="Apellido materno"
                value={formik.values.apellido_materno}
                onChange={formik.handleChange}
                error={formik.errors.apellido_materno}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Nombre <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="nombre"
                placeholder="Nombre(s)"
                value={formik.values.nombre}
                onChange={formik.handleChange}
                error={formik.errors.nombre}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Fecha de nacimiento <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="fecha_nacimiento"
                type="date"
                placeholder="Fecha de nacimiento"
                value={formik.values.fecha_nacimiento}
                onChange={handleFechaNacimientoChange}
                error={formik.errors.fecha_nacimiento}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                CURP <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="curp"
                placeholder="CURP"
                value={formik.values.curp}
                onChange={(e, { name, value }) => {
                  formik.handleChange(e);
                  formik.setFieldValue(name, value.toUpperCase());
                }}
                error={formik.errors.curp}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>Edad</label>
              <Form.Input
                name="edad"
                placeholder="Edad"
                value={formik.values.edad}
                onChange={formik.handleChange}
                error={formik.errors.edad}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Género <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="Género Mujer/Hombre"
                fluid
                selection
                search
                options={generos}
                value={formik.values.sexo}
                error={formik.errors.sexo}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("sexo", datos.value);
                }}
              />
            </div>
            <div className="input-field">
              <label>
                Nacionalidad <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="nacionalidad"
                placeholder="Nacionalidad"
                value={formik.values.nacionalidad}
                onChange={formik.handleChange}
                error={formik.errors.nacionalidad}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Lugar de nacimiento <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="lugar_nacimiento"
                placeholder="Lugar de nacimiento"
                value={formik.values.lugar_nacimiento}
                onChange={formik.handleChange}
                error={formik.errors.lugar_nacimiento}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>Teléfono de casa </label>
              <Form.Input
                name="telefono_casa"
                placeholder=" Teléfono de casa"
                value={formik.values.telefono_casa}
                onChange={formik.handleChange}
                error={formik.errors.telefono_casa}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Teléfono celular <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="telefono_celular"
                placeholder=" Teléfono celular"
                value={formik.values.telefono_celular}
                onChange={formik.handleChange}
                error={formik.errors.telefono_celular}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Correo electrónico <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="email"
                placeholder="Correo electrónico"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.errors.email}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>Tipo sanguíneo </label>
              <Dropdown
                placeholder="Tipo sanguíneo"
                fluid
                selection
                search
                options={tiposDeSangre}
                value={formik.values.tipo_sanguineo}
                error={formik.errors.tipo_sanguineo}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("tipo_sanguineo", datos.value);
                }}
              />
            </div>
            <div className="input-field">
              <label>
                ¿Tiene alguna discapacidad? <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="¿Tiene alguna discapacidad? (si/no)"
                fluid
                selection
                search
                options={optionsSN}
                value={formik.values.discapacidad}
                error={formik.errors.discapacidad}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("discapacidad", datos.value);
                }}
              />
            </div>
            {/* Renderizado condicional: Solo muestra el siguiente input si se selecciona "Si" */}
            {formik.values.discapacidad === "Si" && (
              <div className="input-field">
                <label>
                  ¿Cuál? <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="descripcion_discapacidad"
                  placeholder="¿Cuál?"
                  value={formik.values.descripcion_discapacidad}
                  onChange={formik.handleChange}
                  error={formik.errors.descripcion_discapacidad}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
            <div className="input-field">
              <label>
                ¿Habla alguna lengua indígena?{" "}
                <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="¿Habla alguna lengua indigena? (si/no)"
                fluid
                selection
                search
                options={optionsSN}
                value={formik.values.lengua_indigena}
                error={formik.errors.lengua_indigena}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("lengua_indigena", datos.value);
                }}
              />
            </div>
            {/* Renderizado condicional: Solo muestra el siguiente input si se selecciona "Si" */}
            {formik.values.lengua_indigena === "Si" && (
              <div className="input-field">
                <label>
                  ¿Cuál? <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="descripcion_lengua_indigena"
                  placeholder="¿Cuál?"
                  value={formik.values.descripcion_lengua_indigena}
                  onChange={formik.handleChange}
                  error={formik.errors.descripcion_lengua_indigena}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
          </div>
        </div>
        <div className="fichero">
          <div className="titulo">
            <h3>Domicilio actual</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>
                Código postal <span className="astedisco">*</span>
              </label>
              {alumno ? (
                <Form.Input
                  name="codigo_postal_domicilio"
                  placeholder="Código postal"
                  value={formik.values.codigo_postal_domicilio}
                  error={formik.errors.codigo_postal_domicilio}
                  onChange={handleCPChange}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              ) : (
                <Form.Input
                  name="codigo_postal_domicilio"
                  placeholder="Código postal"
                  onChange={handleCPChange}
                  error={formik.errors.codigo_postal_domicilio}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Estado <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showEstadoInput}
                    onChange={() => setShowEstadoInput(!showEstadoInput)}
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra el estado en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showEstadoInput || alumno ? (
                <Form.Input
                  name="estado_domicilio"
                  placeholder="Estado"
                  value={formik.values.estado_domicilio}
                  error={formik.errors.estado_domicilio}
                  onChange={formik.handleChange}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar estado"
                  fluid
                  search
                  selection
                  options={estadoOptions}
                  value={formik.values.estado_domicilio}
                  error={formik.errors.estado_domicilio}
                  onChange={(_, datos) => {
                    formik.setFieldValue("estado_domicilio", datos.value);
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Colonia <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showColoniaInput}
                    onChange={() => setShowColoniaInput(!showColoniaInput)}
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra la colonia en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showColoniaInput || alumno ? (
                <Form.Input
                  name="colonia_domicilio"
                  placeholder="Colonia"
                  value={formik.values.colonia_domicilio}
                  error={formik.errors.colonia_domicilio}
                  onChange={formik.handleChange}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar colonia"
                  fluid
                  search
                  selection
                  options={coloniaOptions}
                  value={formik.values.colonia_domicilio}
                  error={formik.errors.colonia_domicilio}
                  onChange={(_, datos) => {
                    formik.setFieldValue("colonia_domicilio", datos.value);
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Municipio <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showMunicipioInput}
                    onChange={() => setShowMunicipioInput(!showMunicipioInput)}
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra el municipio en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showMunicipioInput || alumno ? (
                <Form.Input
                  name="municipio_domicilio"
                  placeholder="Municipio"
                  value={formik.values.municipio_domicilio}
                  error={formik.errors.municipio_domicilio}
                  onChange={formik.handleChange}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar Municipio"
                  fluid
                  search
                  selection
                  options={municipioOptions}
                  value={formik.values.municipio_domicilio}
                  error={formik.errors.municipio_domicilio}
                  onChange={(_, datos) => {
                    formik.setFieldValue("municipio_domicilio", datos.value);
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <label>
                Calle <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="calle_domicilio"
                placeholder="Calle"
                value={formik.values.calle_domicilio}
                onChange={formik.handleChange}
                error={formik.errors.calle_domicilio}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Número <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="numero_domicilio"
                placeholder="Número"
                value={formik.values.numero_domicilio}
                onChange={formik.handleChange}
                error={formik.errors.numero_domicilio}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
          </div>
        </div>
        <div className="fichero">
          <div className="titulo">
            <h3>Datos complementarios</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>
                Plantel de procedencia <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="planel_procedencia"
                placeholder="Plantel de procedencia"
                value={formik.values.planel_procedencia}
                onChange={formik.handleChange}
                error={formik.errors.planel_procedencia}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Clave de plantel <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="clave_plantelProc"
                placeholder="Clave de plantel"
                value={formik.values.clave_plantelProc}
                onChange={formik.handleChange}
                error={formik.errors.clave_plantelProc}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Promedio de bachillerato <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="promedio_plantel_procedencia"
                placeholder="Promedio de bachillerato"
                value={formik.values.promedio_plantel_procedencia}
                onChange={formik.handleChange}
                error={formik.errors.promedio_plantel_procedencia}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Servicio médico al que es derechoambiente{" "}
                <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="Servicio médico al que es derechoambiente"
                fluid
                selection
                search
                options={servicioMedico}
                value={formik.values.servicio_medico}
                error={formik.errors.servicio_medico}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("servicio_medico", datos.value);
                }}
              />
            </div>
            {formik.values.servicio_medico !== "NINGUNO" && (
              <div className="input-field">
                <label>
                  No. de afiliación <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="num_afiliacion"
                  placeholder="No. de afiliación"
                  value={formik.values.num_afiliacion}
                  onChange={(e) => {
                    const newValue = e.target.value.trim(); // Obtener el nuevo valor del input eliminando espacios en blanco al inicio y al final
                    formik.setFieldValue("num_afiliacion", newValue || null); // Establecer el nuevo valor en el formulario, si es una cadena vacía, establecer como undefined
                  }}
                  error={formik.errors.num_afiliacion}
                />
              </div>
            )}
            <div className="input-field">
              <label>
                Además de estudiar ¿Trabaja?{" "}
                <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="Además de estudiar ¿Trabaja? (si/no)"
                fluid
                selection
                search
                options={optionsSN}
                value={formik.values.trabajo_activo}
                error={formik.errors.trabajo_activo}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("trabajo_activo", datos.value);
                }}
              />
            </div>
            {/* Renderizado condicional: Solo muestra el siguiente input si se selecciona "Si" */}
            {formik.values.trabajo_activo === "Si" && (
              <div className="input-field">
                <label>
                  ¿En que trabaja? <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="descripcion_trabajo"
                  placeholder="¿En que trabaja?"
                  value={formik.values.descripcion_trabajo}
                  onChange={formik.handleChange}
                  error={formik.errors.descripcion_trabajo}
                  disabled={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
            <div className="input-field">
              <label>
                ¿Depende económicamente de alguien?{" "}
                <span className="astedisco">*</span>
              </label>
              <Dropdown
                placeholder="¿Depende económicamente de alguien? si/no"
                fluid
                selection
                search
                options={optionsSN}
                value={formik.values.dependencia_economica}
                error={formik.errors.dependencia_economica}
                disabled={alumno && alumno.estado_alumno !== "Activo"}
                onChange={(_, datos) => {
                  formik.setFieldValue("dependencia_economica", datos.value);
                }}
              />
            </div>
            {/* Renderizado condicional: Solo muestra el siguiente input si se selecciona "Si" */}
            {formik.values.dependencia_economica === "Si" && (
              <div className="input-field">
                <label>
                  ¿De quién? <span className="astedisco">*</span>
                </label>
                <Form.Input
                  name="descripcion_dependencia"
                  placeholder="¿De quién?"
                  value={formik.values.descripcion_dependencia}
                  onChange={formik.handleChange}
                  error={formik.errors.descripcion_dependencia}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              </div>
            )}
          </div>
        </div>
        <div className="fichero">
          <div className="titulo">
            <h3>Datos del tutor</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>
                Apellido paterno <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="apellido_paterno_tutor"
                placeholder="Apellido paterno"
                value={formik.values.apellido_paterno_tutor}
                onChange={formik.handleChange}
                error={formik.errors.apellido_paterno_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Apellido materno <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="apellido_materno_tutor"
                placeholder="Apellido materno"
                value={formik.values.apellido_materno_tutor}
                onChange={formik.handleChange}
                error={formik.errors.apellido_materno_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Nombre <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="nombre_tutor"
                placeholder="Nombre(s)"
                value={formik.values.nombre_tutor}
                onChange={formik.handleChange}
                error={formik.errors.nombre_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>Teléfono de casa</label>
              <Form.Input
                name="telefono_casa_tutor"
                placeholder="Teléfono de casa"
                value={formik.values.telefono_casa_tutor}
                onChange={formik.handleChange}
                error={formik.errors.telefono_casa_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Teléfono celular <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="telefono_celular_tutor"
                placeholder="Teléfono celular"
                value={formik.values.telefono_celular_tutor}
                onChange={formik.handleChange}
                error={formik.errors.telefono_celular_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>Correo electrónico </label>
              <Form.Input
                name="email_tutor"
                placeholder="Correo electrónico"
                value={formik.values.email_tutor}
                onChange={formik.handleChange}
                error={formik.errors.email_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
          </div>
        </div>
        <div className="fichero">
          <div className="titulo">
            <h3>Domicilio tutor</h3>
          </div>
          <div className="datos">
            <div className="input-field">
              <label>
                Código postal <span className="astedisco">*</span>
              </label>
              {alumno ? (
                <Form.Input
                  name="codigo_postal_domicilio_tutor"
                  placeholder="Código postal"
                  value={formik.values.codigo_postal_domicilio_tutor}
                  error={formik.errors.codigo_postal_domicilio_tutor}
                  onChange={handleCPChangeTutor}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              ) : (
                <Form.Input
                  name="codigo_postal_domicilio_tutor"
                  placeholder="Código postal"
                  onChange={handleCPChangeTutor}
                  error={formik.errors.codigo_postal_domicilio_tutor}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Estado <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showEstadoInputTutor}
                    onChange={() =>
                      setShowEstadoInputTutor(!showEstadoInputTutor)
                    }
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra el estado en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showEstadoInputTutor || alumno ? (
                <Form.Input
                  name="estado_domicilio_tutor"
                  placeholder="Estado"
                  value={formik.values.estado_domicilio_tutor}
                  error={formik.errors.estado_domicilio_tutor}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                  onChange={formik.handleChange}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar estado"
                  fluid
                  search
                  selection
                  options={estadoOptionsTutor}
                  value={formik.values.estado_domicilio_tutor}
                  error={formik.errors.estado_domicilio_tutor}
                  onChange={(_, datos) => {
                    formik.setFieldValue("estado_domicilio_tutor", datos.value);
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Colonia <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showColoniaInputTutor}
                    onChange={() =>
                      setShowColoniaInputTutor(!showColoniaInputTutor)
                    }
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra la colonia en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showColoniaInputTutor || alumno ? (
                <Form.Input
                  name="colonia_domicilio_tutor"
                  placeholder="Colonia"
                  value={formik.values.colonia_domicilio_tutor}
                  error={formik.errors.colonia_domicilio_tutor}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                  onChange={formik.handleChange}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar colonia"
                  fluid
                  search
                  selection
                  options={coloniaOptionsTutor}
                  value={formik.values.colonia_domicilio_tutor}
                  error={formik.errors.colonia_domicilio_tutor}
                  onChange={(_, datos) => {
                    formik.setFieldValue(
                      "colonia_domicilio_tutor",
                      datos.value
                    );
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ marginRight: "10px" }}>
                  Municipio <span className="astedisco">*</span>
                </label>
                {!alumno ? (
                  <input
                    type="checkbox"
                    checked={showMunicipioInputTutor}
                    onChange={() =>
                      setShowMunicipioInputTutor(!showMunicipioInputTutor)
                    }
                  />
                ) : (
                  <></>
                )}
                {!alumno ? (
                  <span> ¿No se encuentra el municipio en la lista?</span>
                ) : (
                  <></>
                )}
              </div>
              {showMunicipioInputTutor || alumno ? (
                <Form.Input
                  name="municipio_domicilio_tutor"
                  placeholder="Municipio"
                  value={formik.values.municipio_domicilio_tutor}
                  error={formik.errors.municipio_domicilio_tutor}
                  readOnly={alumno && alumno.estado_alumno !== "Activo"}
                  onChange={formik.handleChange}
                />
              ) : (
                <Dropdown
                  placeholder="Seleccionar Municipio"
                  fluid
                  search
                  selection
                  options={municipioOptionsTutor}
                  value={formik.values.municipio_domicilio_tutor}
                  error={formik.errors.municipio_domicilio_tutor}
                  disabled={alumno && alumno.estado_alumno !== "Activo"}
                  onChange={(_, datos) => {
                    formik.setFieldValue(
                      "municipio_domicilio_tutor",
                      datos.value
                    );
                  }}
                />
              )}
            </div>
            <div className="input-field">
              <label>
                Calle <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="calle_domicilio_tutor"
                placeholder="Calle"
                value={formik.values.calle_domicilio_tutor}
                onChange={formik.handleChange}
                error={formik.errors.calle_domicilio_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
            <div className="input-field">
              <label>
                Número <span className="astedisco">*</span>
              </label>
              <Form.Input
                name="numero_domicilio_tutor"
                placeholder="Número"
                value={formik.values.numero_domicilio_tutor}
                onChange={formik.handleChange}
                error={formik.errors.numero_domicilio_tutor}
                readOnly={alumno && alumno.estado_alumno !== "Activo"}
              />
            </div>
          </div>
        </div>
        {(alumno === undefined && (
          <Button
            type="submit"
            content="Inscribir alumno"
            className="botonEnviar"
          />
        )) ||
          (alumno && alumno.estado_alumno === "Activo" && (
            <Button
              type="submit"
              content="Actualizar"
              className="botonEnviar"
            />
          ))}
      </Form>
      <ToastContainer />
    </>
  );
}

function formatoDelDropDown(informacionGrupos) {
  // Verificar si informacionGrupos es null o no está definido
  if (!informacionGrupos) {
    return [];
  }
  informacionGrupos.sort((a, b) => a.numero_grupo - b.numero_grupo);
  return map(informacionGrupos, (item) => ({
    key: item.id_grupo,
    text: item.numero_grupo,
    value: item.id_grupo,
  }));
}

function initialValues(datoAlumno, grupos) {
  let grupoAlumno = null;
  if (datoAlumno && grupos) {
    grupos.forEach((grupo) => {
      if (grupo.alumnos.includes(datoAlumno.id)) {
        grupoAlumno = grupo;
      }
    });
  }
  return {
    matricula: datoAlumno?.matricula || "",
    grupo: grupoAlumno?.id_grupo || "",
    semestre: datoAlumno?.semestre || "",
    estado_alumno:
      datoAlumno?.estado_alumno === undefined
        ? "Activo"
        : datoAlumno?.estado_alumno,
    apellido_paterno: datoAlumno?.apellido_paterno || "",
    fecha_baja_temporal_2: datoAlumno?.fecha_baja_temporal_2 || "",
    fecha_baja_temporal_1: datoAlumno?.fecha_baja_temporal_1 || "",
    apellido_materno: datoAlumno?.apellido_materno || "",
    nombre: datoAlumno?.nombre || "",
    fecha_nacimiento: datoAlumno?.fecha_nacimiento || "",
    curp: datoAlumno?.curp || "",
    edad: datoAlumno?.edad || "",
    sexo: datoAlumno?.sexo || "",
    nacionalidad: datoAlumno?.nacionalidad || "",
    lugar_nacimiento: datoAlumno?.lugar_nacimiento || "",
    telefono_casa: datoAlumno?.telefono_casa || "",
    telefono_celular: datoAlumno?.telefono_celular || "",
    email: datoAlumno?.email || "",
    tipo_sanguineo: datoAlumno?.tipo_sanguineo || "",
    discapacidad: datoAlumno?.discapacidad || "",
    descripcion_discapacidad: datoAlumno?.descripcion_discapacidad || "",
    lengua_indigena: datoAlumno?.lengua_indigena || "",
    descripcion_lengua_indigena: datoAlumno?.descripcion_lengua_indigena || "",
    calle_domicilio: datoAlumno?.calle_domicilio || "",
    numero_domicilio: datoAlumno?.numero_domicilio || "",
    colonia_domicilio: datoAlumno?.colonia_domicilio || "",
    municipio_domicilio: datoAlumno?.municipio_domicilio || "",
    estado_domicilio: datoAlumno?.estado_domicilio || "",
    codigo_postal_domicilio: datoAlumno?.codigo_postal_domicilio || "",
    planel_procedencia: datoAlumno?.planel_procedencia || "",
    clave_plantelProc: datoAlumno?.clave_plantelProc || "",
    promedio_plantel_procedencia:
      datoAlumno?.promedio_plantel_procedencia || "",
    servicio_medico: datoAlumno?.servicio_medico || "",
    num_afiliacion: datoAlumno?.num_afiliacion || "",
    trabajo_activo: datoAlumno?.trabajo_activo || "",
    descripcion_trabajo: datoAlumno?.descripcion_trabajo || "",
    dependencia_economica: datoAlumno?.dependencia_economica || "",
    descripcion_dependencia: datoAlumno?.descripcion_dependencia || "",
    apellido_paterno_tutor: datoAlumno?.apellido_paterno_tutor || "",
    apellido_materno_tutor: datoAlumno?.apellido_materno_tutor || "",
    nombre_tutor: datoAlumno?.nombre_tutor || "",
    telefono_casa_tutor: datoAlumno?.telefono_casa_tutor || "",
    telefono_celular_tutor: datoAlumno?.telefono_celular_tutor || "",
    email_tutor: datoAlumno?.email_tutor || "",
    calle_domicilio_tutor: datoAlumno?.calle_domicilio_tutor || "",
    numero_domicilio_tutor: datoAlumno?.numero_domicilio_tutor || "",
    colonia_domicilio_tutor: datoAlumno?.colonia_domicilio_tutor || "",
    municipio_domicilio_tutor: datoAlumno?.municipio_domicilio_tutor || "",
    estado_domicilio_tutor: datoAlumno?.estado_domicilio_tutor || "",
    codigo_postal_domicilio_tutor:
      datoAlumno?.codigo_postal_domicilio_tutor || "",
    alumno_traslado:
      datoAlumno?.alumno_traslado === undefined
        ? false
        : datoAlumno?.alumno_traslado,
  };
}

function newSchema() {
  return {
    grupo: Yup.string().required(true),
    semestre: Yup.string().required(true),
    apellido_paterno: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    apellido_materno: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    nombre: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en el nombre"
    ),
    email: Yup.string()
      .email("Debe ser un correo electrónico válido")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "El correo electrónico no debe contener acentos"
      )
      .required("El correo electrónico es obligatorio"),
    edad: Yup.number()
      .typeError("La edad es requerida en números")
      .min(15, "La edad debe ser mayor o igual que 15")
      .required("La edad es requerida"),
    fecha_nacimiento: Yup.string().required(true),
    curp: Yup.string()
      .required(true)
      .matches(
        /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}[A-Z\d]{1}\d{1}$/,
        "El formato de la CURP no es válido"
      )
      .max(18, "La CURP no debe tener más de 18 caracteres"),
    lugar_nacimiento: Yup.string(),
    sexo: Yup.string().required(true),

    nacionalidad: Yup.string().required(true),
    calle_domicilio: Yup.string(),
    colonia_domicilio: Yup.string(),
    municipio_domicilio: Yup.string(),
    numero_domicilio: Yup.string(),
    estado_domicilio: Yup.string()
      .required(true)
      .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/, "Solo se permiten letras"),
    codigo_postal_domicilio: Yup.string(),
    telefono_celular: Yup.string(),
    telefono_casa: Yup.string(),
    email: Yup.string().email(true),
    discapacidad: Yup.string().required(true),
    lengua_indigena: Yup.string().required(true),
    planel_procedencia: Yup.string(),
    clave_plantelProc: Yup.string(),
    promedio_plantel_procedencia: Yup.string().matches(
      /^\d+(\.\d{1,2})?$/, // Expresión regular para permitir números con hasta 2 decimales
      "El promedio debe contener solo números y hasta con 2 decimales"
    ),
    servicio_medico: Yup.string().required(true),
    //num_afiliacion: Yup.string().required(true),
    trabajo_activo: Yup.string().required(true),
    dependencia_economica: Yup.string().required(true),
    apellido_paterno_tutor: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    apellido_materno_tutor: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    nombre_tutor: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en el nombre"
    ),
    calle_domicilio_tutor: Yup.string(),
    numero_domicilio_tutor: Yup.string(),
    colonia_domicilio_tutor: Yup.string(),
    municipio_domicilio_tutor: Yup.string(),
    estado_domicilio_tutor: Yup.string(),
    codigo_postal_domicilio_tutor: Yup.string(),
    telefono_celular_tutor: Yup.string(),
    telefono_casa_tutor: Yup.string(),
    email_tutor: Yup.string().email(),
  };
}
function updateSquema() {
  return {
    grupo: Yup.string().required(true),
    semestre: Yup.string().required(true),
    apellido_paterno: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    apellido_materno: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    nombre: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en el nombre"
      ),
    email: Yup.string()
      .email("Debe ser un correo electrónico válido")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "El correo electrónico no debe contener acentos"
      )
      .required("El correo electrónico es obligatorio"),
    edad: Yup.number()
      .typeError("La edad es requerida en números")
      .min(15, "La edad debe ser mayor o igual que 15")
      .required("La edad es requerida"),
    fecha_nacimiento: Yup.string().required(true),
    curp: Yup.string()
      .required(true)
      .matches(
        /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}[A-Z\d]{1}\d{1}$/,
        "El formato de la CURP no es válido"
      )
      .max(18, "La CURP no debe tener más de 18 caracteres"),
    lugar_nacimiento: Yup.string(),
    sexo: Yup.string().required(true),

    nacionalidad: Yup.string(),
    calle_domicilio: Yup.string(),
    colonia_domicilio: Yup.string(),
    municipio_domicilio: Yup.string(),
    numero_domicilio: Yup.string(),
    estado_domicilio: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras"
    ),
    codigo_postal_domicilio: Yup.string().matches(
      /^\d{5}$/,
      "El código postal debe contener exactamente 5 dígitos"
    ),
    telefono_celular: Yup.string(),
    telefono_casa: Yup.string(),
    email: Yup.string().email(true),
    discapacidad: Yup.string().required(true),
    lengua_indigena: Yup.string().required(true),
    planel_procedencia: Yup.string(),
    clave_plantelProc: Yup.string(),
    promedio_plantel_procedencia: Yup.string().matches(
      /^\d+(\.\d{1,2})?$/, // Expresión regular para permitir números con hasta 2 decimales
      "El promedio debe contener solo números y hasta con 2 decimales"
    ),
    servicio_medico: Yup.string().required(true),
    //num_afiliacion: Yup.string().required(true),
    trabajo_activo: Yup.string().required(true),
    dependencia_economica: Yup.string().required(true),
    apellido_paterno_tutor: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en los apellidos"
    ),
    apellido_materno_tutor: Yup.string(),
    nombre_tutor: Yup.string().matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
      "Solo se permiten letras en el nombre"
    ),
    calle_domicilio_tutor: Yup.string(),
    numero_domicilio_tutor: Yup.string(),
    colonia_domicilio_tutor: Yup.string(),
    municipio_domicilio_tutor: Yup.string(),
    estado_domicilio_tutor: Yup.string(),
    codigo_postal_domicilio_tutor: Yup.string(),
    telefono_celular_tutor: Yup.string(),
    telefono_casa_tutor: Yup.string(),
    email_tutor: Yup.string().email(),
  };
}
